import { render, staticRenderFns } from "./umat.vue?vue&type=template&id=c2668968&scoped=true&"
import script from "./umat.vue?vue&type=script&lang=js&"
export * from "./umat.vue?vue&type=script&lang=js&"
import style0 from "./umat.vue?vue&type=style&index=0&id=c2668968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2668968",
  null
  
)

export default component.exports